module.exports = __webpack_public_path__ + "static/media/4.32799e2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/4.png
// module id = 1001
// module chunks = 0